import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	searchBarContainer: {
		height: '40px',
		width: '100%',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.medium'),
		marginBottom: token('space.100'),
	},
});

export const SnippetPanelSearchBarSkeleton = () => {
	return <Box xcss={styles.searchBarContainer} />;
};
